import { useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';

export const Container = ({ children, className = '' }) => (
  <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>
);

export const Section = ({ id, children, className = '', testId }) => (
  <section id={id} className={`py-20 lg:py-32 relative ${className}`} data-testid={testId}>{children}</section>
);

export const Overline = ({ children, className = '' }) => <p className={`ld-overline mb-5 ${className}`}>{children}</p>;

export const H2 = ({ children, className = '' }) => (
  <h2 className={`ld-display text-2xl sm:text-3xl lg:text-4xl font-bold leading-snug text-slate-100 ${className}`}>{children}</h2>
);

export const Lead = ({ children, className = '' }) => (
  <p className={`text-base lg:text-lg leading-relaxed text-slate-400 ${className}`}>{children}</p>
);

export const FadeUp = ({ children, delay = 0, className = '' }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  return (
    <motion.div ref={ref} className={className} initial={{ opacity: 0, y: 24 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6, delay, ease: [0.2, 0.8, 0.2, 1] }}>
      {children}
    </motion.div>
  );
};

export const Counter = ({ value, prefix = '', suffix = '', decimals = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - start) / 1600);
      setN(value * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);
  return <span ref={ref} className="ld-mono">{prefix}{n.toFixed(decimals)}{suffix}</span>;
};

export const Logo = ({ className = 'text-2xl' }) => (
  <div className={`woxora-logo ${className}`} data-testid="landing-logo">
    <span className="text-slate-100">Wox</span><span className="text-[#E06D53]">ora</span>
  </div>
);
